import ItemTile from './ItemTile';
import './ItemTile.scss';

export default ItemTile;